/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

const ImageUrlPrefix = Object.freeze({
  S3: '*',
  TWITTER: '@'
})
export default ImageUrlPrefix
// RESERVE BELOW
